var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('gmap-map',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":18}},[_c('gmap-marker',{attrs:{"position":_vm.marker,"icon":"img/brand/Bino.svg","title":"Bosh Prokuratura"},on:{"click":function($event){_vm.center=_vm.m.position}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }